import { render, staticRenderFns } from "./offline_ship_dialog.vue?vue&type=template&id=70e68cec&scoped=true"
import script from "./offline_ship_dialog.vue?vue&type=script&lang=js"
export * from "./offline_ship_dialog.vue?vue&type=script&lang=js"
import style0 from "./offline_ship_dialog.vue?vue&type=style&index=0&id=70e68cec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e68cec",
  null
  
)

export default component.exports